import {
  AuthState,
  AuthTypes,
  UPDATE_SESSION
} from './types'

const initialState: AuthState = process.env.NODE_ENV === 'development' ? {
  id_token: undefined,
  msAuthInstance: undefined,
  userEmail: 'alex@moia.io',
  userName: 'Alex'
} : {
  id_token: undefined,
  msAuthInstance: undefined,
  userEmail: undefined,
  userName: undefined
}

export function authReducer(
  state = initialState,
  action: AuthTypes
): AuthState {
  switch (action.type) {
    case UPDATE_SESSION: {
      return {
        ...state,
        ...action.payload
      }
    }
    default:
      return state
  }
}